export default __webpack_public_path__ + "static/media/share.45bd7c1a.svg";